var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ModalTwoFactorAuth',{ref:"modalAuth"}),_c('ModalIdleWarning',{ref:"modalIdle"}),(_vm.loading)?_c('LoadingBar',{attrs:{"loadingText":"Cargando..."}}):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }